import { render } from "./InlineRouterLink.vue?vue&type=template&id=03f8f29e"
import script from "./InlineRouterLink.vue?vue&type=script&lang=js"
export * from "./InlineRouterLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__